import { useFormikContext } from "formik";
import { useEffect } from "react";
import useDiagnosticoNaturalezaLesionZonaAfectada from "../../../commons/hooks/useDiagnosticoNaturalezaLesionZonaAfectada";
import DiagnosisControl from "./diagnosisControl";

// Este control espera que el form tenga los initial values ya configurados en el form que lo llame
const DiagnosisControlContainer = ({
  idArt,
  showGravedad,
  showDescripcionDiagnostico,
  showDiagnosticoInformadoArt,
  fields,
  disabled,
  disabledIfInitialValueExists,
}) => {
  const { initialValues } = useFormikContext();

  const [
    filteredZonasAfectadas,
    filteredNaturalezasLesion,
    updateFilteredZonasAfectadas,
    updateFilteredNaturalezasLesion,
    getDiagnosticoNaturalezaLesionZonaAfectada,
    setInitialNaturalezaLesionAndZonaAfectada,
    clearDiagnosisInitialInclusions
  ] = useDiagnosticoNaturalezaLesionZonaAfectada(idArt);

  useEffect(() => {
    setInitialNaturalezaLesionAndZonaAfectada(initialValues.naturalezaLesion, initialValues.zonaAfectada);
    getDiagnosticoNaturalezaLesionZonaAfectada(initialValues.diagnosticoOMS, initialValues.naturalezaLesion, initialValues.zonaAfectada)
  }, [initialValues.naturalezaLesion, initialValues.zonaAfectada])
  return (
    <DiagnosisControl
      idArt={idArt}
      disabled={disabled}
      disabledIfInitialValueExists={disabledIfInitialValueExists}
      showGravedad={showGravedad}
      showDescripcionDiagnostico={showDescripcionDiagnostico}
      showDiagnosticoInformadoArt={showDiagnosticoInformadoArt}
      naturalezasLesion={filteredNaturalezasLesion}
      zonasAfectadas={filteredZonasAfectadas}
      updateFilteredNaturalezasLesion={updateFilteredNaturalezasLesion}
      updateFilteredZonasAfectadas={updateFilteredZonasAfectadas}
      getDiagnosticoNaturalezaLesionZonaAfectada={getDiagnosticoNaturalezaLesionZonaAfectada}
      clearDiagnosisInitialInclusions={clearDiagnosisInitialInclusions}
      fields={fields}
    />
  )
}

export default DiagnosisControlContainer;